<template>
  <div id="NotificationList">
    <!-- 操作按鈕 -->
    <div class="toolbar">
      <el-date-picker
        v-model="selectedDateRange"
        value-format="yyyy-MM-dd"
        type="daterange"
        unlink-panels
        :range-separator="$t('General.To')"
        :start-placeholder="$t('General.Start')"
        :end-placeholder="$t('General.End')"
        :picker-options="pickerOptions"
      />
    </div>

    <!-- 通知列表 -->
    <el-table :data="dataList" style="width: 100%">
      <el-table-column prop="TimeStamp" :label="$t('EvCharging.Distributions.Date')" width="200" />
      <el-table-column prop="DistributionName" :label="$t('EvCharging.Distributions.DistributionName')" width="100" />
      <el-table-column prop="ConnectorSn" :label="$t('EvCharging.Distributions.Charger')" width="100" />
      <el-table-column prop="Message" :label="$t('EvCharging.Distributions.NotificationContent')">
        <template slot-scope="{ row }">
          <span :class="getAlertTypeClass(row.Type)">
            {{ row.Message }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="Type" :label="$t('EvCharging.Distributions.Type')" width="120">
        <template slot-scope="{ row }">
          <span :class="getAlertTypeClass(row.Type)">
            {{ getTypeLabel(row.Type) }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="totalCount > 0"
      background
      layout="total, prev, pager, next, jumper"
      :current-page="nowPage"
      :page-size="pageSize"
      :total="totalCount"
      @current-change="getList"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { apiEvCharging } from '@/api/EvCharging'

export default {
  props: {
    chargingFeature: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      totalCount: 0,
      nowPage: 1,
      pageSize: 10, // 每頁筆數
      selectedDateRange: [
        dayjs().format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ],
      dataList: [],
      pickerOptions: {
        shortcuts: [
          { text: this.$t('EvCharging.Distributions.Today'), onClick: (picker) => picker.$emit('pick', [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]) },
          { text: this.$t('EvCharging.Distributions.LastWeek'), onClick: (picker) => picker.$emit('pick', [dayjs().add(-7, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]) },
          { text: this.$t('EvCharging.Distributions.LastMonth'), onClick: (picker) => picker.$emit('pick', [dayjs().add(-30, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]) },
          { text: this.$t('EvCharging.Distributions.LastThreeMonths'), onClick: (picker) => picker.$emit('pick', [dayjs().add(-90, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]) }
        ],
        disabledDate: (time) => time.getTime() < dayjs().add(-90, 'day').startOf('day').toDate().getTime() || time.getTime() > dayjs().toDate().getTime(),
        clearable: false
      },
      typeMappings: {
        3: { label: this.$t('EvCharging.Distributions.Abnormal'), class: 'error' },
        2: { label: this.$t('EvCharging.Distributions.Warning'), class: 'warning' },
        1: { label: this.$t('EvCharging.Distributions.Normal'), class: 'normal' }
      }
    }
  },
  watch: {
    chargingFeature: {
      immediate: true,
      handler (val) {
        // 如果有分配電盤者，才獲取列表
        if (val?.HasDistributor) {
          this.getList(1)
        }
      }
    },
    selectedDateRange: {
      handler () {
        this.getList(1)
      },
      deep: true
    }
  },
  methods: {
    getList (page = 1) {
      this.nowPage = page
      const req = this.buildRequest(page)

      apiEvCharging.PowerDistribution.getDistributorAlertLog(req).then(res => {
        const sortedList = res.data.Data.LogList.sort((a, b) => {
          return dayjs(b.TimeStamp).valueOf() - dayjs(a.TimeStamp).valueOf()
        })
        this.dataList = sortedList
        this.totalCount = res.data.Data.TotalCount
      }).catch(err => {
        console.log(err)
      })
    },
    buildRequest (page = 1) {
      const [start, end] = this.selectedDateRange || []
      return {
        StartAt: dayjs(start).format('YYYY/MM/DD'),
        EndAt: dayjs(end).format('YYYY/MM/DD'),
        Offset: (page - 1) * this.pageSize,
        MaxCount: this.pageSize
      }
    },
    getAlertTypeClass (type) {
      return this.typeMappings[type]?.class || ''
    },
    getTypeLabel (type) {
      return this.typeMappings[type]?.label || '-'
    }
  }
}
</script>

<style lang="scss" scoped>
#NotificationList {
  padding: 20px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 10px;

  .toolbar {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
    justify-content: space-between;
  }

  .error {
    color: $dangerColor;
    font-weight: bold;
  }

  .warning {
    color: $evChargingWarning;
    font-weight: bold;
  }

  .normal {
    font-weight: bold;
  }
  .el-pagination{
    margin-top: 20px;
    text-align: left
  }
}
</style>
